import React, { useEffect, useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import moment from "moment";

import { fetchWrapper } from "@helpers/fetchwrapper";
import Docs from "./Docs";
import styles from "./styles/categories.module.css";
 
function Categories() {
  const [activeTab, setActiveTab] = useState("1");
  const [load, setLoad] = useState(false);
  const [practices, setPractices] = useState([]);
  

  const loadPractices = () => {
    setLoad(true);
     fetchWrapper.get("/data/best_practices.json").then((res) => {
          setLoad(false);
          setPractices(res);
        });
  };

 

  useEffect(() => {
    loadPractices();
  }, []);

  return (
    <div className={`container ${styles.block}`}>
      <Nav tabs className={styles.tabs}>
        <NavItem>
          <NavLink
            className={`${styles.tab} ${styles.start} ${
              activeTab === "1" ? styles.active : null
            }`}
            onClick={() => {
              loadPractices();
              setActiveTab("1");
            }}
          >
            Практики по наставничеству
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={`${styles.tab} ${styles.end} ${
              activeTab === "2" ? styles.active : null
            }`}
            onClick={() => {              
              setActiveTab("2");
            }}
          >
            Методический материал
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            {load ? (
              <div className="d-flex w-100 justify-content-center mt-4">
                <ClipLoader />
              </div>
            ) : (
              <div className={styles.tabContent}>
                {practices.map((practice) => (
                  <div className={styles.card}>                    
                    <div className={styles.type}>{practice.NameCompany}</div>
                    <div className={styles.header}>{practice.Name}</div>
                    <div className={styles.description}>{practice.Description}</div>
                    <div className={styles.footer}>
                      <div className={styles.date}>                      
                      </div>
                      <Link
                        to={`${practice.doc_url}`}
                        target="_blank"
                        className={styles.addition}
                      >
                        Ознакомиться подробнее →
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </TabPane>
          <TabPane tabId="2">
            <Docs></Docs>
          </TabPane>
        </TabContent>
      </TabContent>
      
    </div>
  );
}

export default Categories;
